import { SvgIcon, SxProps } from "@mui/material";
import ReactionSadSvg from "jsx:../../../Images/Icons/Custom/reactionSad.svg";

export function ReactionSadIcon(props: SxProps) {
    return <SvgIcon component={ReactionSadSvg} inheritViewBox sx={props} />;
}
